// ABOUTME: One history arrow beside the rail: Back to the screen before, or Forward to the one after a Back.
// ABOUTME: Unavailable or blocked arrows look dimmed and ignore presses but are never disabled; an unavailable forward arrow is aria-hidden.

import { IconButton } from '@mui/material';
import { CROSSING_ARROW_INK, CROSSING_BORDER_PILL, CROSSING_FOCUS_RING, CROSSING_PAPER } from '../../../theme/crossingTokens';

interface HistoryArrowProps {
  direction: 'back' | 'forward';
  target: string | null; // the name of the screen it leads to (progress.backTo / forwardTo)
  available: boolean; // the record has somewhere to go in this direction
  blocked: boolean; // a save is in flight or the crossing is closed
  onPress: () => void;
}

export default function HistoryArrow({ direction, target, available, blocked, onPress }: HistoryArrowProps) {
  const label = target ? `${direction === 'back' ? 'Back' : 'Forward'} to ${target}` : direction === 'back' ? 'Back' : 'Forward';
  const hidden = direction === 'forward' && !available;
  const dimmed = !available || blocked;
  return (
    <IconButton
      data-arrow={direction}
      aria-label={label}
      aria-hidden={hidden || undefined}
      aria-disabled={dimmed || undefined}
      tabIndex={hidden ? -1 : undefined}
      onClick={() => { if (!dimmed) onPress(); }}
      sx={{
        width: 26, height: 26, minWidth: 26, padding: 0, flexShrink: 0, borderRadius: '999px',
        border: `1px solid ${CROSSING_BORDER_PILL}`, backgroundColor: CROSSING_PAPER, color: CROSSING_ARROW_INK,
        fontSize: '13px', lineHeight: 1, opacity: dimmed ? 0.72 : 1, cursor: dimmed ? 'default' : 'pointer',
        '&:hover': { backgroundColor: CROSSING_PAPER },
        '&.Mui-focusVisible, &:focus-visible': { outline: `2px solid ${CROSSING_FOCUS_RING}`, outlineOffset: 2 },
      }}
    >
      {direction === 'back' ? '←' : '→'}
    </IconButton>
  );
}
